module.exports = __webpack_public_path__ + "img/voucher_ori.0f41969b.png";